var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-4122 -9328)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2411",
    "data-name": "Rectangle 2411",
    width: 20,
    height: 20,
    transform: "translate(4122 9328)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3076",
    "data-name": "Group 3076",
    transform: "translate(8827 10830)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(-4704 -1498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M12.936,14.678,12.323,11l-.613,3.678a1.323,1.323,0,1,0,1.226,0Z",
    transform: "translate(-3.286 -5.857)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M.643,12.857v-.51a9,9,0,1,1,16.714,0v.51Zm15.633-1.286a7.714,7.714,0,1,0-14.551,0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M3.608,15.885l-.4-1.222,2.446-.794.4,1.223ZM6.973,9.811,5.462,7.731,6.5,6.975,8.014,9.056ZM9.5,6H10.79V8.571H9.5ZM5.656,12.3l-2.445-.795.4-1.223,2.445.795Zm8.979,0-.4-1.223,2.447-.794.4,1.222ZM12.278,9.056l1.512-2.08,1.041.756L13.32,9.812Zm4.407,6.83-2.446-.794.4-1.222,2.446.794Z",
    transform: "translate(-1.147 -4.071)",
    fill: "current"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.4d01d59c12410a033d80e9d1ecceabfd.svg";
export { ForwardRef as ReactComponent };